export default __webpack_public_path__ + "static/media/checked.fdb2513f.svg";